import React from "react";
import Sidebar from "./Sidebar";

export default function MyIncidents() {
    return (
        <div>
            <Sidebar />
            <h1>My Incidents</h1>
        </div>
    );
}